import { register } from "./serviceWorkerRegistration";
import config from "./config";

const registerServiceWorker = () => {
  register(config);
};

export default registerServiceWorker;
